import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionEyebrow } from './ui/SectionEyebrow';
const steps = [{
  num: '01',
  title: 'Submit Request',
  desc: 'Requesters use a secure, structured portal to submit RFIs with required fields and attachments.'
}, {
  num: '02',
  title: 'Route & Assign',
  desc: 'Supervisors review and assign tasks, or let automated rules route them to the right analyst.'
}, {
  num: '03',
  title: 'Investigate',
  desc: 'Teams work within a unified interface, collaborating securely and tracking all findings.'
}, {
  num: '04',
  title: 'Deliver & Report',
  desc: 'Final products are delivered securely with consistent reporting, and every step is logged for compliance.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-iris-black border-y border-iris-border overflow-hidden" data-id="element-128">
      <Container data-id="element-129">
        <div className="mb-16" data-id="element-130">
          <SectionEyebrow text="Workflow" className="mb-4" data-id="element-131" />
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white" data-id="element-132">
            HOW IRIS WORKS
          </h2>
        </div>

        <div className="relative" data-id="element-133">
          {/* Connecting Line Background */}
          <div className="absolute top-6 left-0 w-full h-[1px] bg-iris-border hidden md:block" data-id="element-134"></div>

          {/* Animated Connecting Line */}
          <motion.div className="absolute top-6 left-0 h-[1px] bg-iris-green hidden md:block" initial={{
          width: '0%'
        }} whileInView={{
          width: '100%'
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} data-id="element-135"></motion.div>

          <div className="grid md:grid-cols-4 gap-10 relative z-10" data-id="element-136">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2 + 0.5
          }} className="relative" data-id="element-137">
                {/* Node */}
                <div className="w-12 h-12 bg-iris-surface border-2 border-iris-green rounded-full flex items-center justify-center font-mono text-sm text-iris-green font-bold mb-6 relative z-10" data-id="element-138">
                  {step.num}
                </div>

                <h3 className="text-xl font-display font-bold text-white mb-3 uppercase tracking-wide" data-id="element-139">
                  {step.title}
                </h3>
                <p className="text-iris-muted text-sm leading-relaxed" data-id="element-140">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </Container>
    </section>;
}